import { useEffect, useState, useCallback } from 'react';
import { socketService } from '../services/socket';
import { SocketEvents } from '../types';

export const useSocket = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const socket = socketService.connect();
    
    const handleConnect = () => setIsConnected(true);
    const handleDisconnect = () => setIsConnected(false);
    const handleError = (data: { message: string }) => setError(data.message);

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('error', handleError);

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('error', handleError);
    };
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    isConnected,
    error,
    clearError,
    socket: socketService,
  };
};

export const useSocketEvent = <K extends keyof SocketEvents>(
  event: K,
  callback: SocketEvents[K],
  deps: any[] = []
) => {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket) return;

    socket.on(event, callback);

    return () => {
      socket.off(event, callback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket, event, callback, ...deps]);
};
